@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           [fieldSize]="size()"
           type="text"
           [placeholder]="placeholderText()"
           [ngModel]="filterText()"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [fieldSize]="size()"
           #searchInput
           [(ngModel)]="filterText"
           [placeholder]="placeholderText()"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           (keydown.enter)="$event.preventDefault()"
           fullWidth />
    @if (value) {
      <button nbSuffix nbButton ghost (click)="onClear()">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
      </button>
    }
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="loadMore()" [threshold]="50" [throttleTime]="100">
        @if (showEmptyOption()) {
          <nb-list-item (click)="onAllSelected()">
            <div class="tenant alle">Alle</div>
          </nb-list-item>
        }
        @for (tenant of tenants(); track tenant.id) {
          <nb-list-item (click)="onSelectionChange(tenant)">
            <div class="tenant">
              @switch (tenant.type) {
                @case ('Internal') { <nb-icon pack="fas" icon="people-group"></nb-icon> }
                @case ('External') { <nb-icon pack="fas" icon="people-roof"></nb-icon> }
                @case ('Contractor') { <nb-icon pack="fas" icon="hammer"></nb-icon> }
              }
              <span class="tenant-name">{{ tenant.name }}</span>
              <span class="tenant-type">({{ tenantTypePipe.transform(tenant.type) }})</span>
            </div>
          </nb-list-item>
        }
      </nb-list>
    </div>
  </ng-template>
}
